import React, { Component, Fragment } from "react";
import { Row, Col, Button, ModalBody, ModalFooter, Alert } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FormValidators from "ui/FormValidators";
import {
   DateFormatter,
   UpwardReduxInput,
   UpwardLoadingButton,
   UpwardReduxTextEditor,
   UpwardReduxSelect,
   ReduxCityInputAutosuggest,
   ReduxAddressInputAutosuggest,
   ReduxZipInputAutofill,
   ReduxStateSelect
} from "ui";
import JobTitleSuggestion from './JobTitleSuggestion';
import JobDescriptionsUI from './JobDescriptionsUI';
import UpwardAutoSuggestRedux from '../components/autoSuggest/UpwardAutoSuggestRedux';

import { logInUser, freeRegistrationJob } from "../../services/EmployerServices";
import { ThemeContext } from "../../context/ThemeContext";

import { toIntStringCurrency, toIntString } from "redux/form/normalize";
import { intStringToCurrencyDisplay, intStringToCurrencyString } from "redux/form/format";

const validityOptions = [
   { value: 'filled', label: 'Until Filled' },
   { value: '30', label: '30 Days' },
   { value: '60', label: '60 Days' },
   { value: '90', label: '90 Days' },
];

const jobTypeOptions = [
   { value: 'fulltime', label: 'Full-Time' },
   { value: 'parttime', label: 'Part-Time' },
   { value: 'contractor', label: 'Contractor' },
   { value: 'temporary', label: 'Temporary' },
   { value: 'internship', label: 'Temporary to Permanent' }
];

const compensationFrequencyOptions = [
   { value: 'annually', label: 'Annually' },
   { value: 'monthly', label: 'Monthly' },
   { value: 'bi-weekly', label: 'Bi-Weekly' },
   { value: 'daily', label: 'Daily' },
   { value: 'hourly', label: 'Hourly' }
];

const minLength1 = FormValidators.minLength(1);
const minLength10 = FormValidators.minLength(10);

class EmployerJobDetails extends Component {

   constructor(props) {
      super(props);
      this.state = {
         jobCreated: false,
         jobId: '',
         previewUrl: '',
         organization: '',
         errorMessage: ["We were unable to create your job at this time. Please try again. If you continue running into this issue, please contact us at support@upward.net."],
         isError: false,
         isSuccess: false,
         isLoading: false,
         jobValidityDate: new Date(),
         validThrough: '',
         showJobValidityDatePicker: false,
         isValidityPickerEditable: false,
         isCompensationRangeVisible: false
      };
   }

   componentDidMount() {
      const payload = {
         username: this.props.email,
         password: this.props.password,
         rememberMe: true,
         "remember-me": true,
      };
      setTimeout(() => {
         logInUser(payload).subscribe(
            (loginResponse) => {
               console.log(3,loginResponse);
               if (loginResponse.response === "success") {
                  localStorage.setItem("token", loginResponse.message);
               }
            }
         )
      }, 1000);
   }

   handleSubmit = (formData) => {   

      this.setState({
         isLoading: true,
         errorMessage: ["We were unable to create your job at this time. Please try again. If you continue running into this issue, please contact us at support@upward.net."]
      });
      const location = (formData.city ? (formData.city + ', ') : '') + (formData.state ? (formData.state + ' ') : '') + formData.zip;
      const {
         infoEmploymentType,
         infoCompensationType,
         validThroughPicker,
         infoCompensation,
         infoCompensationMin,
         infoCompensationMax,
         ...formDataRemaining
      } = formData;

      const formDataSubmit = {
         validThrough: this.state.validThrough,
         publish: 'y',
         location: location,
         infoEmploymentType: infoEmploymentType && infoEmploymentType.value,
         infoCompensationType: infoCompensationType && infoCompensationType.value,
         validThroughPicker: validThroughPicker && validThroughPicker.value,
         ...formDataRemaining
      };

      if (infoCompensation !== "") {
         formDataSubmit.infoCompensation = intStringToCurrencyString(infoCompensation);

      } else {
         if (infoCompensationMin !== "") {
            formDataSubmit.infoCompensationMin = intStringToCurrencyString(infoCompensationMin);
         }

         if (infoCompensationMax !== "") {
            formDataSubmit.infoCompensationMax = intStringToCurrencyString(infoCompensationMax);
         }

      }
      freeRegistrationJob(formDataSubmit).subscribe(data => {
         if (data && data.outcome) {
            this.setState({
               jobCreated: data.jobCreated,
               jobId: data.jobId || '',
               previewUrl: data.previewUrl || '',
               isError: false
            });

            window.location.href = "/t/employer/job/edit/" + data.jobId + "?boost=true&terms=true";
            
         } else {

            if (data.errorMsgs && data.errorMsgs.length) {
               let newErrorMessage = data.errorMsgs.join(" ").length ? data.errorMsgs.join(" ") : 'We were unable to create your job at this time. Please try again. If you continue running into this issue, please contact us at support@upward.net.';
               this.setState({
                  isLoading: false,
                  isSuccess: false,
                  errorMessage: newErrorMessage,
                  isError: true,

               });
            } else {
               this.setState({
                  isLoading: false,
                  isSuccess: false,
                  isError: true,
               });
            }
         }
      }, err => console.log(err));

   };

   //handles the validity date display and selction on picking from the validity dropdown
   handleValidityChange = selectedOption => {
      let today = new Date();
      if (selectedOption !== 'filled') {
         this.setState({
            showJobValidityDatePicker: true
         });
      }
      if (selectedOption.value === '30') {
         let newValidityDate = new Date(today.setDate(today.getDate() + 30));
         const setValidThrough = newValidityDate.getFullYear() + '-' + (newValidityDate.getMonth() + 1) + '-' + (newValidityDate.getDate());
         this.setValidityDate(newValidityDate, setValidThrough);
      } else if (selectedOption.value === '60') {
         let newValidityDate = new Date(today.setDate(today.getDate() + 60));
         const setValidThrough = newValidityDate.getFullYear() + '-' + (newValidityDate.getMonth() + 1) + '-' + (newValidityDate.getDate());
         this.setValidityDate(newValidityDate, setValidThrough);
      } else if (selectedOption.value === '90') {
         let newValidityDate = new Date(today.setDate(today.getDate() + 90));
         const setValidThrough = newValidityDate.getFullYear() + '-' + (newValidityDate.getMonth() + 1) + '-' + (newValidityDate.getDate());
         this.setValidityDate(newValidityDate, setValidThrough);
      } else if (selectedOption.value === 'filled') {
         this.setState({
            showJobValidityDatePicker: false,
            validThrough: ''
         });
      } else {
      }
   };

   setValidityDate = (newValidityDate, validThrough) => {
      this.setState({
         jobValidityDate: newValidityDate,
         validThrough
      });
   };

   //handles the validity date on picking from date picker
   handleValidityDateChange = date => {
      const newValidThrough = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      this.setValidityDate(date, newValidThrough);
   };

   //handles if validity date picker shows
   toggleValidityPickerEditing = () => {
      this.setState({
         isValidityPickerEditable: !this.state.isValidityPickerEditable
      });
   };

   //handles if compensation range shows
   toggleCompensationRange = () => {
      const { change } = this.props;
      change("infoCompensation", "");
      change("infoCompensationMin", "");
      change("infoCompensationMax", "");
      this.setState({
         isCompensationRangeVisible: !this.state.isCompensationRangeVisible
      });

   };

   toggleErrorAlert = () => {
      this.setState({
         isError: !this.state.isError
      });
   };

   toggleSucessAlert = () => {
      this.setState({
         isSuccess: !this.state.isSuccess
      });
   };

   render() {
      const { handleSubmit } = this.props;
      const { isLoading } = this.state;
      return (
         <Fragment>
            {/* <Progress value="50" color="warning" /> */}
            <div className="modal-header pt-3">
               <h5 className="modal-title" style={{ fontSize: "48px" }}>
                  Job details
               </h5>
            </div>
            <form onSubmit={handleSubmit(this.handleSubmit)}>
               <ModalBody>
                  <Alert
                     color="danger"
                     isOpen={this.state.isError}
                     toggle={this.toggleErrorAlert}
                     className="custom-alert-failure"
                  >
                     { this.state.errorMessage }
                  </Alert>
                  <Row>
                     <Col xs={{ "size": 10, "offset": 1 }}>
                        <div className="form-group roundLgInput">
                           {/*
                              <Field component={UpwardReduxInput}
                                 validate={[FormValidators.required]}
                                 type="text" name="title" id="titleOfJob" autoComplete="off" placeholder="Job Title"
                              />
                           */}
                           <Field
                              type="text"
                              name="title"
                              id="title"
                              childComponent={JobTitleSuggestion}
                              component={UpwardAutoSuggestRedux}
                              placeholder="Job Title"
                              validate={[FormValidators.required, minLength1]}
                           />
                           <JobDescriptionsUI />
                        </div>

                        <div className="form-group roundLgInput">
                           <Field
                              name="jobDescription"
                              id="jobDescription"
                              placeholder="Job Description"
                              component={UpwardReduxTextEditor}
                              validate={
                                 [
                                    FormValidators.required,
                                    minLength10
                                 ]
                              }
                           />
                        </div>

                        <div className="form-group roundLgInput">

                           <Field
                              component={UpwardReduxSelect}
                              options={jobTypeOptions}
                              validate={[FormValidators.required]}
                              placeholder="Job Type"
                              name="infoEmploymentType"
                              autoComplete="off"
                           />
                        </div>

                        {/* Compensation block starts*/}
                        <div className="form-group row no-gutters mb-0">

                           {
                              !this.state.isCompensationRangeVisible &&
                              <div className=" roundLgInput freeJob col-8">
                                 <Field
                                    component={UpwardReduxInput}
                                    normalize={toIntStringCurrency}
                                    format={intStringToCurrencyDisplay}
                                    type="text"
                                    name="infoCompensation"
                                    autoComplete="off"
                                    placeholder="Compensation" />
                              </div>
                           }

                           {
                              this.state.isCompensationRangeVisible &&
                              <Fragment>
                                 <div className=" roundLgInput freeJob col-4">
                                    <Field
                                       component={UpwardReduxInput}
                                       normalize={toIntStringCurrency}
                                       format={intStringToCurrencyDisplay}
                                       type="text"
                                       name="infoCompensationMin"
                                       autoComplete="off"
                                       placeholder="Min" />
                                 </div>
                                 <div className=" roundLgInput freeJob col-4 pl-2">
                                    <Field
                                       component={UpwardReduxInput}
                                       normalize={toIntStringCurrency}
                                       format={intStringToCurrencyDisplay}
                                       type="text"
                                       name="infoCompensationMax"
                                       autoComplete="off"
                                       placeholder="Max" />
                                 </div>
                              </Fragment>
                           }

                           <div className=" roundLgInput col-4 pl-2">

                              <Field
                                 component={UpwardReduxSelect}
                                 options={compensationFrequencyOptions}
                                 placeholder="Frequency"
                                 name="infoCompensationType"
                                 autoComplete="off"
                              />
                           </div>

                        </div>

                        <div className="form-group pt-0">
                           <Button
                              color="link"
                              onClick={this.toggleCompensationRange}
                              className="pl-0">
                              {
                                 this.state.isCompensationRangeVisible
                                    ? 'One Salary Field'
                                    : 'Add Salary Range'
                              }
                           </Button>
                        </div>
                        {/* Compensation block ends*/}


                        {/* Validity Picker block starts*/}
                        <div className="form-group row no-gutters mb-0">

                           <div
                              className="form-group roundLgInput freeJob col-6">
                              {/* </div><div className="form-group roundLgInput freeJob col-5"> */}

                              <Field
                                 component={UpwardReduxSelect}
                                 options={validityOptions}
                                 validate={[FormValidators.required]}
                                 placeholder="Valid Through"
                                 name="validThroughPicker"
                                 autoComplete="off"
                                 onChange={this.handleValidityChange}
                              />
                           </div>
                           {
                              (
                                 this.state.showJobValidityDatePicker
                                 && !this.state.isValidityPickerEditable
                              )
                              &&
                              <div className="jobDatePicker col-3 pt-2 pl-4">
                                 <p>
                                    <DateFormatter timeStamp={this.state.validThrough} isTodayString={false} />
                                 </p>
                              </div>
                           }
                           {
                              (
                                 this.state.showJobValidityDatePicker
                                 && this.state.isValidityPickerEditable
                              )
                              &&
                              <div className=" jobDatePicker col-6 pl-2">
                                 <DatePicker
                                    selected={this.state.jobValidityDate}
                                    onChange={this.handleValidityDateChange}
                                    minDate={new Date()} />
                              </div>
                           }
                           {
                              (
                                 this.state.showJobValidityDatePicker
                                 && !this.state.isValidityPickerEditable)
                              &&
                              <Col
                                 xs={{ "size": 2, "offset": 1 }}
                                 lg={{ "size": 3, "offset": 0 }}>
                                 <Button
                                    color="link"
                                    onClick={this.toggleValidityPickerEditing}
                                    className="pl-0 pt-2">(edit)
                                 </Button>
                              </Col>
                           }
                        </div>
                        {/* Validity Picker block ends*/}

                        {/* Organization block starts*/}
                        <div className="form-group roundLgInput">
                           <Field
                              component={UpwardReduxInput}
                              type="text"
                              name="organization"
                              placeholder="Hiring Company"
                              validate={[FormValidators.required, minLength1]}
                              autoComplete="off" />
                        </div>
                        {/* Organization block ends*/}


                        <div className="form-group roundLgInput addressOfJobDummyClass">
                           <Field
                              name="address1"
                              component={ReduxAddressInputAutosuggest}
                              type="text"
                           />
                        </div>

                        <div className="form-group roundLgInput row no-gutters cityOfJobDummyClass">
                           <div className="col-5 roundLgInput">
                              <Field
                                 name="city"
                                 component={ReduxCityInputAutosuggest}
                                 validate={[FormValidators.required]}
                                 type="text"
                                 autoComplete="off"
                                 placeholder="City"
                                 className={"form-control form-control-lg"}
                              />
                           </div>
                           <div className="col-4 freeJobState px-2">
                              <Field
                                 name="state"
                                 component={ReduxStateSelect}
                                 validate={[FormValidators.required]}
                                 type="text"
                                 autoComplete="off"
                                 placeholder="State"
                                 required={true}
                              />
                           </div>
                           <div className="col-3 roundLgInput ">
                              <Field
                                 component={ReduxZipInputAutofill}
                                 name="zip"
                                 normalize={toIntString}
                                 autoComplete="off"
                                 placeholder="Zip"
                                 validate={
                                    [
                                       FormValidators.number,
                                       FormValidators.required,
                                       FormValidators.zipLength
                                    ]
                                 }
                              />
                           </div>
                        </div>
                     </Col>
                  </Row>

               </ModalBody>
               <ModalFooter>
                  <Row>
                     <Col xs={{ "size": 10, "offset": 1 }} lg={{ "size": 6, "offset": 3 }}>
                        <UpwardLoadingButton
                           block
                           type="submit"
                           color="primary"
                           size="lg"
                           isLoading={isLoading}
                           className={"btn btn-xl btn-block btn-rounded btn-dark-" + this.context}
                        >
                           <b>Continue</b>
                        </UpwardLoadingButton>
                     </Col>
                  </Row>
               </ModalFooter>
            </form>
         </Fragment>
      )
   }
}

EmployerJobDetails.contextType = ThemeContext;

export default reduxForm({
   form: 'employerJobDetails',
})(EmployerJobDetails)
